<template>
  <div class="app-content" :style="{width: computedWidth+'px', height: computedHeight+'px'}">
    <div class="block content-top">
      <tool-bar :checkRowList="checkRow" @clearCheckRow="clearCheckRow" :fileRouterList="fileRouterList" :breadTitle="breadTitle"
                @deleteCheckRow="deleteCheckRow" @openMoToDirDialog="openMoToDirDialog" @uploadFileList="listFileChangeHandler"
      @openShareDialog="openShareDialog" @clickConfirmAddOrRemoveTag="clickConfirmAddOrRemoveTag"
      :operateType="operateType" :tagsListAdd="tagsListAdd" :tagsListRemove="tagsListRemove"></tool-bar>
      <el-breadcrumb v-if="checkRow.length > 0" separator-class="el-icon-arrow-right" style="margin: 12px;font-size: 12px;">
        <el-breadcrumb-item>已选择{{checkRow.length}}个文件／文件夹</el-breadcrumb-item>
      </el-breadcrumb>

      <el-breadcrumb v-else separator-class="el-icon-arrow-right" style="margin: 12px;font-size: 12px;color: #409EFF;">
        <el-breadcrumb-item v-if="fileRouterList.length > 0"><a @click="returnLastFile" style="color: #409EFF;">返回上一级</a></el-breadcrumb-item>
        <el-breadcrumb-item><a @click="returnAllFile" :style="{color: breadTitle.color}">{{breadTitle.tagName}}</a></el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, idx) in fileRouterList" :key="idx"><a @click="returnFile(item)" :style="{color: item.color}">{{item.fileName}}</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="display: flex;flex-direction: row">
      <div :class="{'content-body': isArrange}"  :style="{width: (computedWidth-320)+'px', height: (computedHeight-100)+'px'}">
        <!-------------------文件列表 start----------------------->
        <el-table ref="multipleTable" v-show="!isArrange" :data="fileAllList"  @cell-mouse-enter="onHoverCellEnter" @cell-mouse-leave="onHoverCellLeave"
                  @select-all="onCheckRow" :default-sort = "{prop: 'fileSize', order: 'descending'}"
                  @selection-change="onCheckRow" id="app_content_file_table"
                  :height="tableHeight" :style="{'width': tableWidth+'px'}" highlight-current-row @row-click="onClickRow">
          <el-table-column align="left" type="selection" width="55"> </el-table-column>
          <el-table-column align="left" label="文件名称" width="250">
            <template slot-scope="scope">
              <div :id="scope.row.fileGuid" @mouseover="hoverFileName(scope.row)">
                <el-popover trigger="hover" :open-delay=1500>
                  <p>{{ scope.row.fileName }}</p>
                  <div slot="reference" class="name-wrapper">
                    <div style="display: flex;flex-direction: row;align-items: center"  v-if="scope.row.fileSource===1">
                      <img class="file-name-img" :src="baseUrl+scope.row.img" style="margin-top: 0;">
                      <el-button type="text" :style="{color: scope.row.fontColor}" @click="clickFileName(scope.row)" class="too-long user-select" style="padding-left: 10px;">{{scope.row.fileName}}</el-button>
                    </div>
                    <!--<el-button v-if="scope.row.fileSource===1" type="text" :style="{color: scope.row.fontColor}" @click="clickFileName(scope.row)" :icon="scope.row.icon" class="too-long user-select">{{scope.row.fileName}}</el-button>-->
                    <div style="display: flex;flex-direction: row;align-items: center" v-else>
                      <img class="file-name-img" :src="baseUrl+scope.row.img">
                      <el-button type="text" :style="{color: scope.row.fontColor}" @click="clickFileName(scope.row)" class="too-long user-select" style="padding-left: 10px;">{{scope.row.fileName}}</el-button>
                    </div>
                  </div>
                </el-popover>
                <!--<el-button v-else type="text" :style="{color: scope.row.fontColor}" @click="clickFileName(scope.row)" class="too-long user-select">{{scope.row.fileName}}</el-button>-->
              </div>
            </template>
          </el-table-column>
          <el-table-column align="left" width="70px">
            <template slot-scope="scope" v-if="scope.row.showOperateFlag && srcPage!==3 && showMenuBar && ((scope.row.category === 3 && scope.row.fileSource !== 1)||scope.row.isDir===0)">
              <div class="btn-operate">
                <el-dropdown trigger="hover">
                  <el-button type="text" size="mini" icon="el-icon-more" class="icon-more" :style="{color: scope.row.iconColor}"></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="!disabledDownloadBtn" class="btn-dropdown"><a class="btn-tag list-btn download-a" type="text" @click="onClickDownload($event, 'download_list_page_file_a1')" id="download_list_page_file_a1" target="_blank">下载</a></el-dropdown-item>
                    <el-dropdown-item :divided="!disabledDownloadBtn" v-if="showAddTagBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag download-a" type="text" @click="clickMoveToTag">添加标签</el-button></el-dropdown-item>
                    <el-dropdown-item v-if="showRemoveTagBar" class="btn-dropdown"> <el-button class="btn-tag file-btn-tag" type="text" @click="clickRemoveTag">移除标签</el-button></el-dropdown-item>
                    <el-dropdown-item divided v-if="showRenameBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag" type="text" @click="clickRenameFile">重命名</el-button></el-dropdown-item>
                    <el-dropdown-item divided class="btn-dropdown"><el-button class="btn-tag list-btn file-btn-tag" type="text" @click="clickShare">分享</el-button></el-dropdown-item>
                    <el-dropdown-item divided v-if="showMoveToDirBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag" type="text" @click="clickMoveToDir">移动至</el-button></el-dropdown-item>
                    <el-dropdown-item divided v-if="showDeleteBar" class="btn-dropdown"><el-button class="btn-tag list-btn file-btn-tag" type="text" @click="clickDelete">删除</el-button></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="left" width="70px">
            <template slot-scope="scope" v-if="scope.row.fileDesc">
              <el-popover trigger="hover">
                <p>说明: {{ scope.row.fileDesc }}</p>
                <div slot="reference" class="name-wrapper">
                  <div class="btn-operate">
                    <el-button type="text" size="mini" icon="el-icon-info" class="icon-more" :style="{color: scope.row.iconColor}"></el-button>
                    <!--<el-button type="text" size="mini" icon="el-icon-share"></el-button>-->
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="left" sortable label="大小" width="90">
            <template slot-scope="scope">
              <span>{{scope.row.fileSize}}</span>
            </template>
          </el-table-column>
          <!--<el-table-column align="left" prop="creator" label="创建人"> </el-table-column>-->
          <el-table-column v-if="srcPage!==3" align="left" prop="updateDT" sortable label="修改时间" min-width="120px"> </el-table-column>
          <el-table-column v-if="srcPage===3" align="left" prop="deleteDT" sortable label="删除时间" min-width="120px"> </el-table-column>
        </el-table>
        <!-------------------文件图标 start----------------------->
        <div v-show="isArrange" class="arrange" id="app_content_file_card">
          <el-card :shadow="item.shadow" :body-style="{ padding: '0px', width: '130px' }" v-for="(item, idx) in fileAllList"
                   style="margin: 12px;height: 155px;border: unset;" :key="idx+99">
            <div :id="item.fileGuid" style="width: 100%;height: 100%;"  @mouseover="hoverFileName(item)"
                 @mouseout="leaveFileName(item)">
              <div slot="header" style="margin-top: 10px; text-align: left;">
                <div>
                  <!--<div v-if="!item.showCheckBox"  style="height: 22px;"></div>-->
                  <el-checkbox v-if="item.showCheckBox"  style="text-align: left;" :checked="item.isChecked" @change="onCheckCard(item)"></el-checkbox>
                  <el-dropdown trigger="click" style="margin-left: 12px;" v-if="item.showOperateFlag && srcPage!==3 && showMenuBar && ((item.category === 3 && item.fileSource !== 1)||item.isDir===0)">
                    <el-button type="text" size="mini" icon="el-icon-more" class="icon-more" :style="{color: item.iconColor}"></el-button>
                    <el-dropdown-menu trigger="click" slot="dropdown">
                      <el-dropdown-item v-if="!disabledDownloadBtn" class="btn-dropdown"><a class="btn-tag list-btn file-btn-tag download-a" type="text" @click="onClickDownload($event, 'download_list_page_file_a2')" id="download_list_page_file_a2" target="_blank">下载</a></el-dropdown-item>
                      <el-dropdown-item :divided="!disabledDownloadBtn" v-if="showAddTagBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag" type="text" @click="clickMoveToTag">添加标签</el-button></el-dropdown-item>
                      <el-dropdown-item v-if="showRemoveTagBar" class="btn-dropdown"> <el-button class="btn-tag file-btn-tag" type="text" @click="clickRemoveTag">移除标签</el-button></el-dropdown-item>
                      <el-dropdown-item divided v-if="showRenameBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag" type="text" @click="clickRenameFile">重命名</el-button></el-dropdown-item>
                      <el-dropdown-item divided class="btn-dropdown"><el-button class="btn-tag file-btn-tag" type="text" @click="clickShare">分享</el-button></el-dropdown-item>
                      <el-dropdown-item divided v-if="showMoveToDirBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag" type="text" @click="clickMoveToDir">移动至</el-button></el-dropdown-item>
                      <el-dropdown-item divided v-if="showDeleteBar" class="btn-dropdown"><el-button class="btn-tag file-btn-tag list-btn" type="text" @click="clickDelete">删除</el-button></el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-popover v-if="item.showDesc" trigger="click">
                    <p>说明: {{ item.fileDesc }}</p>
                    <div slot="reference" class="name-wrapper">
                      <div align="right" v-if="item.showDesc" style="margin-top: -20px"><i class="el-icon-info icon-more" :style="{color: item.iconColor}"></i></div>
                    </div>
                  </el-popover>
                </div>
              </div>
              <div class="arrange-list" @click="clickFileName(item)">
                <img class="arrange-img file" :src="baseUrl+item.img">
                <el-popover trigger="hover" :open-delay="openDelay">
                  <p>{{ item.fileName }}</p>
                  <div slot="reference" class="too-long span-card">
                    <span class="arrange-span too-long" :style="{color: item.fontColor}">{{item.fileName}}</span>
                  </div>
                </el-popover>
                <!--<span class="arrange-span too-long" :style="{color: item.fontColor}">{{item.fileName}}</span>-->
              </div>
            </div>
          </el-card>
        </div>
        <!-------------------文件列表 end----------------------->
      </div>
      <div class="banner-set" :style="{'height': bannerHeight+'px'}">
        <banner></banner>
      </div>
    </div>
    <!-------------------文件右键菜单 start----------------------->
    <!--<context-menu class="right-menu" v-if="srcPage===3"-->
                  <!--:show="contextMenuVisible === 'file'"-->
                  <!--@update:show="(show) => contextMenuVisible = show">-->
      <!--<el-button class="btn-tag" type="text" @click="clickRestore" style="margin-left: 0;">还原文件</el-button>-->
    <!--</context-menu>-->
    <!--<context-menu class="right-menu" v-else-if="showMenuBar"-->
                  <!--:show="contextMenuVisible === 'file'"-->
                  <!--@update:show="(show) => contextMenuVisible = show">-->
      <!--<a v-if="!disabledDownloadBtn" class="btn-tag list-btn" type="text" :href="'http://192.168.2.156:8080/cloud/fileRequest?fileGUID='+contextMenuFile.fileGuid" target="_blank">下载</a>-->
      <!--<div class="line-div"></div>-->
      <!--<el-button class="btn-tag" type="text" @click="clickMoveToTag" style="margin-left: 0;">添加标签</el-button>-->
      <!--<el-button class="btn-tag" type="text" @click="clickRemoveTag" style="margin-left: 0;">移除标签</el-button>-->
      <!--<div class="line-div"></div>-->
      <!--<el-button class="btn-tag" type="text" @click="clickRenameFile" style="margin-left: 0;">重命名</el-button>-->
      <!--<div class="line-div"></div>-->
      <!--<el-button class="btn-tag" type="text" @click="clickDelete" style="margin-left: 0;">删除</el-button>-->
    <!--</context-menu>-->
    <!-------------------文件右键菜单 end----------------------->
    <el-dialog
      :title="tagDialogTitle"
      :visible.sync="centerDialogVisible"
      width="24%"
      top="20%">
      <el-input v-if="operateType === 4"
        placeholder="请输入文件名称"
        v-model="inputFileName"
        clearable>
      </el-input>
      <el-select v-else v-model="selectedTag" placeholder="请选择">
        <el-option
          v-for="item in tagsListOptions"
          :key="item.tagId"
          :label="item.tagName"
          :value="item.tagId">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="operateType === 4" type="primary" size="mini" @click="clickConfirmRenameFile">确 定</el-button>
        <el-button v-else type="primary" size="mini" @click="clickConfirmAddOrRemoveTag" :disabled="selectedTag === null">确 定</el-button>
      </span>
    </el-dialog>
    <move-to-dir @clearCheckRowList="clearCheckRowList" :fileRouterList="fileRouterList" :openDialogVisiable="showMoveDirDialog" @closeDialog="closeMoveToDirDialog" :checkRowList="checkRowMoveTo" @deleteCheckRow="deleteCheckRow"></move-to-dir>
    <share :openDialogVisiable="showShareDialog" @closeDialog="closeShareDialog" :checkRowList="checkRowMoveTo" @deleteCheckRow="deleteCheckRow"></share>
  </div>
</template>
<script>
import toolBar from './ToolBar.vue'
import banner from './Banner.vue'
import { mapState, mapMutations } from 'vuex'
import ct from '../utils/constant.js'
import contextMenu from '../components/VueContextMenu.vue'
import moveToDir from '../components/dialog/MoveToDir.vue'
import share from '../components/dialog/Share.vue'
export default {
  created () {
    window.addEventListener('resize', this.resizeHandler())
  },
  mounted () {
    console.log('mounted-all-file')
  },
  props: [],
  data () {
    return {
      selectedTag: '',
      centerDialogVisible: false,
      inputFileName: '',
      tagDialogTitle: '',
      contextMenuVisible: '',
      computedLeft: window.innerWidth, // toolBar margin-left属性
      baseUrl: 'static/img/',
      checkRow: [],
      hoverRow: null,
      fileRouterList: [],
      showOperateFlag: true,
      fontColor: '#303133',
      iconColor: 'gray',
      tableHeight: this.computedHeight - 100,
      tableWidth: this.computedWidth - 300,
      bannerHeight: this.computedHeight - 59,
      contextMenuFile: {},
      operateType: null,
      fileTagsList: [],
      initCode: 1,
      fileAllList: [],
      clickRow: null,
      showMoveDirDialog: false,
      showShareDialog: false,
      isDownload: 0,
      rowDownloadCode: 0,
      downloadIdA: ''
    }
  },
  components: {
    toolBar,
    banner,
    contextMenu,
    moveToDir,
    share
  },
  watch: {
    'currentTag': {
      handler: function (val) {
        this.fileRouterList.splice(0, this.fileRouterList.length)
        this.checkRow = []
      },
      deep: true
    },
    'filesList': {
      handler: function (val) {
        let res = []
        if (!this.filesList) {
          return
        }
        this.filesList.forEach(file => {
          let obj = {}
          if (file.parentGuid) {
            obj.showOperateFlag = this.showOperateFlag
            obj.fontColor = this.fontColor
            obj.createDT = file.createDT
            obj.updateDT = file.updateDT
            obj.deleteDT = file.deleteDT
            let n = file.fileName
            obj.creator = file.creator
            obj.fileGuid = file.fileGuid
            obj.fileName = n
            obj.fileOwner = file.fileOwner
            obj.fileSource = file.fileSource
            obj.isDir = file.isDir
            obj.parentGuid = file.parentGuid
            obj.fileSize = this.getFileSize(file.fileSize)
            obj.fileSizeSrc = file.fileSize
            obj.elementId = file.fileGuid
            obj.fileDesc = file.fileDesc
            obj.category = file.category
            obj.operationStatus = file.operationStatus
            obj.presentationStatus = file.presentationStatus
            obj.iconColor = this.iconColor
            obj.tags = file.tags
            let curList = this.fileAllList.filter(f => f.fileGuid === file.fuleGuid)[0]
            if (curList) {
              obj.isChecked = curList.isChecked
              obj.shadow = curList.shadow
              obj.showCheckBox = curList.showCheckBox
              obj.showDesc = curList.showDesc
            } else {
              obj.isChecked = false
              obj.shadow = 'hover'
              obj.showCheckBox = false
              obj.showDesc = false
            }
            if (obj.isDir === 1) {
              obj.img = 'dir.png'
              // if (obj.fileSource === ct.UploadOrReleaseType.cus && obj.category === ct.FileType.gc) {
              //   obj.img = 'favicon.ico'
              //   // obj.icon = 'el-icon-cus-G'
              // } else if (obj.fileSource === ct.UploadOrReleaseType.cus && obj.category === ct.FileType.cus) {
              //   obj.img = 'customer.png'
              //   // obj.icon = 'el-icon-cus-customer'
              // }
            } else {
              if (n.indexOf('png') > -1 || n.indexOf('jpg') > -1) {
                obj.img = 'image.png'
              } else if (n.indexOf('rmvb') > -1 || n.indexOf('avi') > -1 || n.indexOf('mp4') > -1 || n.indexOf('wmv') > -1) { // rm rmvb mpeg avi asf wmv vod dat 3gp
                obj.img = 'video.png'
              } else if (n.indexOf('zip') > -1 || n.indexOf('tar') > -1 || n.indexOf('tar.gz') > -1) {
                obj.img = 'zip.png'
              } else if (n.indexOf('rar') > -1) {
                obj.img = 'rar.png'
              } else if (n.indexOf('pdf') > -1) {
                obj.img = 'pdf.png'
              } else {
                obj.img = 'file.png'
              }
            }
            res.push(obj)
            this.setCurrentFileList(res)
          } else {
            this.setRootFile(file)
            this.setCurrentDirGuid(file.fileGuid)
          }
        })
        this.fileAllList = res
      },
      deep: true
    },
    'computedHeight': function (val) {
      this.tableHeight = val - 100
      this.bannerHeight = val - 59
    },
    'computedWidth': function (val) {
      this.tableWidth = val - 320
    },
    'fileRouterList': function (val) {
      for (let i = 0; i < val.length; i++) {
        let r = val[i]
        if (i === val.length - 1) {
          r.color = '#2c3e50'
        } else {
          r.color = '#409EFF'
        }
      }
    },
    'isDownload': function (val) {
      let a = document.getElementById(this.downloadIdA)
      a.href = 'fileRequest?fileGUID=' + this.contextMenuFile.fileGuid
      a.click()
      let _this = this
      setTimeout(function () {
        _this.$msgbox.close()
      }, 200)
    }
  },
  methods: {
    ...mapMutations(['setFilesList', 'setTagsList', 'setRootFile', 'setCurrentDirGuid', 'setContextMenuElement',
      'setTarget', 'setCurrentFileList', 'setFileRouterList', 'setShowMoveDirDialog', 'setHrefFlag']),
    closeMoveToDirDialog () {
      this.showMoveDirDialog = false
    },
    closeShareDialog () {
      this.showShareDialog = false
    },
    clearCheckRowList () {
      this.checkRow = []
      this.$refs.multipleTable.clearSelection()
    },
    resizeHandler () {
      this.tableHeight = this.computedHeight - 100
      this.tableWidth = this.computedWidth - 320
      this.bannerHeight = this.computedHeight - 59
    },
    initFilesList () {
      this.initCode = Math.random() * 100000
    },
    onClickRow (row) {
      row.fontColor = '#409EFF'
      this.clickRow = row
    },
    onHoverCellEnter (row, column, cell, event) {
      // if (this.checkRow.length === 0) {
      // this.hoverRow = row
      // row.showOperateFlag = true
      this.contextMenuFile = row
      row.fontColor = '#409EFF'
      row.iconColor = '#409EFF'
      // }
    },
    onHoverCellLeave (row, column, cell, event) {
      // if (this.checkRow.length === 0) {
      // this.hoverRow = null
      // row.showOperateFlag = false
      row.fontColor = '#303133'
      row.iconColor = 'gray'
      // }
    },
    onCheckRow (sel) {
      this.checkRow = sel
    },
    clickFileName (file) {
      if (file.isDir === ct.Boolean.no) {
        this.$refs.multipleTable.toggleRowSelection(file)
        return
      }
      this.checkRow = []
      this.getListData(file)
      if (this.fileRouterList.filter(item => item.fileGuid === file.fileGuid).length === 0) {
        // file.color = '#409EFF'
        this.fileRouterList.push(file)
        // this.fileRouterList[this.fileRouterList.length - 1].color = '#2c3e50'
        this.setFileRouterList(this.fileRouterList)
      }
      // this.initFilesList()
    },
    hoverFileName (file) {
      this.setContextMenuElement(document.getElementById(file.fileGuid))
      this.setTarget('file')
      file.fontColor = '#409EFF'
      file.iconColor = '#409EFF'
      this.contextMenuFile = file
      if (this.isArrange) {
        file.showCheckBox = true
        if (file.fileDesc && file.fileDesc !== '') {
          file.showDesc = true
        }
      }
    },
    leaveFileName (file) {
      if (this.isArrange) {
        if (!file.isChecked) {
          file.showCheckBox = false
        }
        file.fontColor = '#303133'
        file.iconColor = 'gray'
        file.showDesc = false
      }
    },
    onCheckCard (file) {
      file.isChecked = !file.isChecked
      if (file.isChecked) {
        file.shadow = 'always'
        this.checkRow.push(file)
        // file.showCheckBox = true
      } else {
        this.checkRow.splice(this.checkRow.indexOf(file), 1)
        file.shadow = 'hover'
        // file.showCheckBox = false
      }
    },
    getListData (file) {
      if (!file) {
        return
      }
      let target = null
      if (this.isArrange) {
        target = document.getElementById('app_content_file_card')
      } else {
        target = document.getElementById('app_content_file_table')
      }
      let loading = this.$loading({text: '拼命加载中', target: target, spinner: 'el-icon-loading'})
      this.postRequest('loadFilesByFileGuid', {startIndex: 0, pageSize: 0, orderColumn: ct.OrderColumn.updateDT, isDesc: true, parentGuid: file.fileGuid}).then(res => {
        this.setCurrentDirGuid(file.fileGuid)
        this.setFilesList(res.data.result)
        loading.close()
      })
    },
    returnFile (file) {
      this.getListData(file)
      this.fileRouterHandler(file)
    },
    fileRouterHandler (file) {
      let index = this.fileRouterList.indexOf(file) + 1
      let length = this.fileRouterList.length - index
      this.fileRouterList.splice(index, length)
      this.setFileRouterList(this.fileRouterList)
    },
    returnAllFile () {
      // console.log('returnAllFile')
      let bread = this.breadTitle
      if (bread.category === ct.TagCategory.all) {
        this.getListData(this.rootFile)
      } else {
        this.getFilesByTag(bread.tagId)
      }
      this.fileRouterList.splice(0, this.fileRouterList.length)
      this.setFileRouterList(this.fileRouterList)
    },
    returnLastFile () {
      // console.log('returnLastFile')
      let router = this.fileRouterList
      let len = router.length
      if (len < 2) {
        this.returnAllFile()
      } else {
        let file = router[router.length - 2]
        this.getListData(file)
        this.fileRouterHandler(file)
      }
    },
    getFilesByTag (id) {
      this.postRequest('loadFilesByTag', {orderColumn: ct.OrderColumn.updateDT, isDesc: true, tagId: id}).then(res => {
        this.setFilesList(res.data.result)
      })
    },
    clickRestore () {
      // todo
    },
    onClickDownload (e, id) {
      // eslint-disable-next-line
      this.downloadIdA = id
      this.$confirm(ct.DownloadFileTip, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // confirm
        this.isDownload = Math.random() * 1000
      }).catch(() => {
        // cancel
      })
      if (this.isDownload === this.rowDownloadCode) {
        e.preventDefault()
      }
      this.isDownload = this.rowDownloadCode
    },
    clickMoveToDir () {
      this.checkRowList = [this.contextMenuFile]
      this.openMoToDirDialog()
    },
    clickShare () {
      this.openShareDialog()
    },
    clickMoveToTag () {
      this.tagDialogTitle = '添加标签'
      this.operateType = ct.OperateFileType.moveToTag
      this.centerDialogVisible = true
    },
    clickRenameFile () {
      this.operateType = ct.OperateFileType.rename
      this.tagDialogTitle = '重命名文件'
      this.centerDialogVisible = true
      this.inputFileName = this.contextMenuFile.fileName
    },
    clickRemoveTag () {
      this.tagDialogTitle = '移除标签'
      this.operateType = ct.OperateFileType.removeTag
      this.centerDialogVisible = true
    },
    clickConfirmAddOrRemoveTag (fromToolFlag = false, operateType = undefined, selectedTag = undefined) {
      console.log('clickConfirmAddOrRemoveTag')
      // eslint-disable-next-line
      let ty = operateType ? operateType : this.operateType
      let param = {}
      if (ty === ct.OperateFileType.removeTag) {
        let guid = ''
        if (this.checkRow.length === 1) {
          guid = this.checkRow[0].fileGuid
        } else {
          guid = this.contextMenuFile.fileGuid
        }
        // eslint-disable-next-line
        param = {tagId: selectedTag ? selectedTag : this.selectedTag, fileGuid: guid}
        this.postRequest('deleteFileTag', param).then(res => {
          if (res && res.data.code === 0) {
            this.operationTips(this)
            this.centerDialogVisible = false
            this.selectedTag = ''

            if (this.srcPage === ct.SrcPage.tag || !fromToolFlag) {
              this.getFilesByTag(this.currentTag.tagId)
              this.fileChangeHandler(res)
            } else {
              this.checkRow = []
              this.$refs.multipleTable.clearSelection()
            }
          }
        })
      } else if (ty === ct.OperateFileType.moveToTag) {
        let arr = []
        if (this.checkRow.length > 0) {
          this.checkRow.forEach(r => {
            arr.push(r.fileGuid)
          })
        } else {
          arr.push(this.contextMenuFile.fileGuid)
        }
        param = {tagId: selectedTag || this.selectedTag, fileGuids: arr}
        this.postRequest('addFileTag', param).then(res => {
          if (res && res.data.code === 0) {
            this.operationTips(this)
            this.centerDialogVisible = false
            this.selectedTag = ''
            this.listFileChangeHandler(res.data.result)
          }
        })
      }
    },
    clickConfirmRenameFile () {
      let flag = false
      this.filesList.some(f => {
        if (f.fileName === this.inputFileName) {
          flag = true
          // return
        }
      })
      if (flag) {
        this.$message({message: '请勿提交重复的文件名称哦～', type: 'error'})
        return
      }
      this.postRequest('renameFile', {fileGuid: this.contextMenuFile.fileGuid, fileName: this.inputFileName}).then(res => {
        if (res && res.data.code === 0) {
          this.operationTips(this)
          this.fileChangeHandler(res)
          this.selectedTag = ''
        }
      })
      this.centerDialogVisible = false
    },
    clickAddOrRemoveTag () {
      // todo
    },
    listFileChangeHandler (list) {
      // console.log('listFileChangeHandler', list)
      let files = this.filesList
      for (let i = 0; i < list.length; i++) {
        let l = list[i]
        for (let j = 0; j < files.length; j++) {
          let f = files[j]
          if (l.fileGuid === f.fileGuid) {
            files.splice(j, 1, l)
            break
          }
        }
      }
      this.setFilesList(files)
    },
    fileChangeHandler (res) {
      let list = this.filesList
      let index = null
      for (let i = 0; i < list.length; i++) {
        if (list[i].fileGuid === this.contextMenuFile.fileGuid) {
          index = i
          break
        }
      }
      list.splice(index, 1, res.data.result)
      this.setFilesList(list)
    },
    clickDelete () {
      let arr = []
      arr.push(this.contextMenuFile.fileGuid)
      this.postRequest('deleteFile', arr).then(res => {
        if (res && res.data.code === 0) {
          this.operationTips(this)
          let list = this.filesList
          list = list.filter(l => l.fileGuid !== this.contextMenuFile.fileGuid)
          this.setFilesList(list)
          this.contextMenuVisible = ''
        }
      })
    },
    deleteCheckRow () {
      this.checkRow = []
    },
    openMoToDirDialog () {
      this.showMoveDirDialog = true
    },
    openShareDialog () {
      this.showShareDialog = true
    },
    clearCheckRow () {
      if (this.isArrange) {
        this.checkRow.forEach(val => {
          let item = this.fileAllList.filter(f => f.fileGuid === val.fileGuid)[0]
          if (item) {
            item.isChecked = true
            item.shadow = 'always'
            item.showCheckBox = true
          }
        })
      } else {
        this.checkRow.forEach(val => {
          let item = this.fileAllList.filter(f => f.fileGuid === val.fileGuid)[0]
          if (item) {
            item.isChecked = false
            item.shadow = 'hover'
            item.showCheckBox = false
            // console.log('!isArrange')
            this.$nextTick(() => {
              // this.$refs.multipleTable.toggleRowSelection(item)
            })
            // this.$refs.multipleTable.toggleRowSelection(item)
          }
        })
      }
    },
    breadTitleColor (tag) {
      if (tag) {
        if (this.fileRouterList.length === 0) {
          let h = this.getStorage('urlFlagParam')
          let flag = false
          if (parseInt(h) === ct.UrlFlag.fromEmail) {
            flag = true
          }
          if (flag) {
            tag.color = '#409EFF'
            tag.flag = h
          } else {
            tag.color = '#2c3e50'
            tag.flag = null
          }
        } else {
          tag.color = '#409EFF'
        }
      }
    }
  },
  computed: {
    ...mapState(['filesList', 'currentTag', 'rootFile', 'computedHeight', 'isArrange', 'tagsList', 'srcPage', 'currentFileList', 'computedHeight', 'computedWidth', 'hrefFlag']),
    breadTitle () {
      let tagParam = this.$route.query.tag
      if (tagParam) {
        let tag = JSON.parse(tagParam)
        this.breadTitleColor(tag)
        return tag
      }
      let tag = this.currentTag
      if (tag && tag !== null) {
        this.breadTitleColor(tag)
        return tag
      }
      return {}
    },
    tagsListOptions () {
      let ty = this.operateType
      if (ty === ct.OperateFileType.moveToTag) { // add tag
        return this.tagsListAdd
      } else if (ty === ct.OperateFileType.removeTag) { // remove tag
        return this.tagsListRemove
      }
    },
    tagsListAdd () {
      let tagsExist = {}
      let row = this.checkRow
      if (row.length > 0) {
        tagsExist = row[0].tags
      } else {
        tagsExist = this.contextMenuFile.tags
      }
      if (!tagsExist) {
        return []
      }
      let tags = this.tagsList.filter(t => t.tagType === 2)
      if (tagsExist.length > 0) {
        console.log('tagsListAdd')
        for (let i = 0; i < tagsExist.length; i++) {
          let t = tagsExist[i]
          for (let j = 0; j < tags.length; j++) {
            let tag = tags[j]
            if (t.tagId === tag.tagId) {
              tags.splice(j, 1)
            }
          }
        }
      }
      return tags
    },
    tagsListRemove () {
      let tags = this.checkRow[0] ? this.checkRow[0].tags : []
      if (tags) {
        return tags
      } else {
        return this.contextMenuFile.tags
      }
    },
    disabledDownloadBtn () {
      let file = this.contextMenuFile
      return file.isDir === ct.Boolean.yes // 文件夹不能下载
      // file.operationStatus === ct.Boolean.no
    },
    showRemoveTagBar () {
      if (this.tagsListRemove) {
        return this.tagsListRemove.length !== 0
      }
      return false
    },
    showAddTagBar () {
      if (this.tagsListAdd) {
        return this.tagsListAdd.length !== 0
      }
      return false
    },
    showMenuBar () {
      return this.checkRow.length < 2
    },
    showMoveToDirBar () {
      return this.showBar
    },
    showDeleteBar () {
      return this.showBar
    },
    showRenameBar () {
      return this.showBar
    },
    showShareBar () {
      return this.showBar
    },
    showBar () {
      let file = this.contextMenuFile
      return file.category === ct.FileType.cus && file.fileSource !== ct.UploadOrReleaseType.cus
    },
    checkRowMoveTo () {
      if (this.checkRow.length > 0) {
        return this.checkRow
      }
      return [this.contextMenuFile]
    },
    openDelay () {
      return 2000
    }
  }
}
</script>

<style>
.banner-set {
  right: 0;
  /*overflow: scroll;*/
  border-left: 1px solid #eaecf2;
  margin-top: -36px;
  position: absolute;
  /*height: 100%;*/
}
  .content-body {
    /*width:75%;*/
    overflow-y: scroll;
  }

  .arrange {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*overflow-y: scroll;*/
    /*overflow-x: hidden;*/
    height: 700px;
  }

  .arrange-img {
    width: 100px;
    padding: 0 24px 0 24px;
  }

  .file{
    width: 80px;
  }

  .arrange-list {
    display: flex;
    flex-direction: column;
    /*margin: 12px 0 12px 0;*/
  }

  .arrange-span {
    font-size: 14px;
    padding: 0 12px;
    width: 100px;
    word-break: break-all;
    margin: 0px 5px 5px;
  }

  .too-long {
    text-overflow:ellipsis;
    white-space:nowrap;
    overflow:hidden;
  }

  .user-select {
    user-select: unset;
  }

  .hover-arrange {
    border: solid 1px gainsboro;
    border-radius: 5px;
    /*box-shadow: 5px 5px 2px #888888;*/
  }

  .line-div {
    border-bottom: solid 1px gainsboro;
  }

  .arrange .el-card__body {
    margin-top: -10px;
  }

  .arrange .el-card__header {
    border: unset;
    padding: 0px;
    margin-bottom: 8px;
    text-align: left;
  }

  .list-btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-size: 14px;
    border-radius: 4px;
    font-weight: 500;
    color: #409EFF;
    background: 0 0;
    border: unset;
    text-decoration: unset;
    font-family: inherit;
  }

  .icon-more {
    margin-right: 20px;
  }

  .span-card{
    justify-content: center;
    display: flex;
    align-items: center;
  }

  .download-a {
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0;
  }

  .btn-dropdown {
    width: 100px;
    padding: 0 10px;
  }

  .file-btn-tag {
    margin-left: 0;
    width:100%;
  }

  .el-dropdown-menu__item--divided:before {
    height:0;
  }
  .file-name-img {
    width: 20px;
    height: 20px;
    /*margin-right: 10px;*/
    margin-top: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FileList.vue